import type { PricingCalculatorContent } from "./fetch.ts";
import type { ComparePlanItem } from "./types.ts";
import type { Plan, PlanLimitConfigs, CcpPricingData } from "../types.ts";

export function getComparePlansDataFromGqlContent(
    gqlContent: PricingCalculatorContent,
    planLimitConfigs: PlanLimitConfigs[],
    ccpPricingData: CcpPricingData
): Plan[] {
    const items: ComparePlanItem[] =
        gqlContent.pricingCollection.items[0]?.comparePlansCollection.items ??
        [];

    return items.flatMap((item, index) => {
        const sku = planLimitConfigs[index]?.offeringSku ?? "";
        const pricingPlan = ccpPricingData[sku];
        if (!pricingPlan) {
            return [];
        }
        return [
            {
                fields: {
                    planTitleInternal: "",
                    planTitleExternal: item.planTitleExternal,
                    planOneLiner: item.planOneLiner,
                    sku,
                    highlightedFeaturesTitle:
                        item.highlightedFeaturesTitle ?? "",
                    highlightedFeaturesContainer:
                        item.highlightedFeaturesContainerCollection.items.map(
                            (feature) => ({
                                fields: {
                                    highlightedFeatureTitleInternal: "",
                                    highlightedFeatureTitleExternal:
                                        feature.highlightedFeatureTitleExternal,
                                    highlightedFeatureDetails:
                                        feature.highlightedFeatureDetails?.json,
                                    highlightedLabel:
                                        feature.callOut ?? undefined
                                }
                            })
                        ),
                    microCta: item.microCtaCollection.items.map((cta) => ({
                        fields: {
                            ctaMicrocopyNameInternal: "",
                            ctaMicrocopyTitleExternal:
                                cta.ctaMicrocopyTitleExternal,
                            ctaButtonText: cta.ctaButtonText,
                            ctaUrl: cta.ctaUrl
                        }
                    })),
                    relatedProduct: []
                },
                pricingPlan
            }
        ];
    });
}
